var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module",style:(_vm.bgStyle)},[_c('module_titlle',{attrs:{"title":_vm.title,"title_en":_vm.title_en}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }